// extracted by mini-css-extract-plugin
export default {"ferry-page":"Index_ferry-page__def+p","ferry-page__info":"Index_ferry-page__info__WRmG9"};